<template>
  <div>
    <ExpansionPanel enclosed name="animations">
      <div slot="summary">
        <Icon name="crosshairs" class="mr-2 text-primary" />
        Animation
      </div>
      <div slot="details" class="py-4 grid gap-4 grid-cols-1">
        <SelectControl
          label="Entrance Animation"
          :path="nest('entranceAnimation')"
        >
          <Option
            v-for="{animation, name} in animations"
            :key="animation"
            :value="animation"
            >{{ name }}</Option
          >
        </SelectControl>
      </div>
    </ExpansionPanel>

    <ExpansionPanel enclosed name="visibility">
      <div slot="summary">
        <Icon name="eye" class="mr-2 text-primary" />
        Visibility
      </div>
      <VisibilityControl :path="nest('hideOn')" slot="details" />
    </ExpansionPanel>

    <ExpansionPanel enclosed name="advanced">
      <div slot="summary">
        <Icon name="database" class="mr-2 text-primary" />
        Advanced
      </div>
      <div class="py-4 grid gap-4">
        <InputFieldCopy
          label="Component ID"
          fullWidth
          :value="id"
          tippy="This can be used to create a scroll link or add custom CSS"
        >
        </InputFieldCopy>

        <TextControl
          :path="nest('customClass')"
          label="Custom class"
          :labelProps="{
            tippy: `<b>Advanced feature</b> to add a custom class to
        the component. To add multiple classes simply add a space.`,
          }"
        />
      </div>
    </ExpansionPanel>
  </div>
</template>

<script>
import createControlMixin from '../create-control-mixin';
import VisibilityControl from '../VisibilityControl';
import SelectControl from '../SelectControl';
import TextControl from '../TextControl';

export default {
  components: {
    VisibilityControl,
    SelectControl,
    TextControl,
  },
  mixins: [createControlMixin()],

  data: () => ({
    animations: [
      {
        animation: 'fadeIn',
        name: 'Fade In',
      },
      {
        animation: 'fadeInRight',
        name: 'Fade In Right',
      },
      {
        animation: 'fadeInLeft',
        name: 'Fade In left',
      },
      {
        animation: 'fadeInUp',
        name: 'Fade In Up',
      },
      {
        animation: 'fadeInDown',
        name: 'Fade In Down',
      },
    ],
  }),
  props: {
    path: {
      default: 'base',
      type: String,
    },
  },

  computed: {
    id() {
      return '#' + this.$store.getters.selectedElement.id;
    },
    pageSlug() {},
  },
};
</script>
